const ShareInDetail = {
  mounted() {
    this.handleClick = (e) => {
      e.preventDefault();
      if ("clipboard" in navigator) {
        let currentHostURL =
          window.location.protocol + "//" + window.location.hostname;
        if (window.location.port != "") {
          currentHostURL += ":" + window.location.port;
        }
        let url = currentHostURL + window.location.pathname;

        navigator.clipboard.writeText(url);
      } else {
        alert(
          "Sorry, your browser does not support clipboard copy. \n You can copy the url from the browser address bar.",
        );
      }
    };
    this.el.addEventListener("click", this.handleClick);
  },
  destroyed() {
    this.el.removeEventListener("click", this.handleClick);
  },
};

export default ShareInDetail;
